import React from 'react';
import './PastChampions.css';

const champions = [
  {
    name: "Derrick",
    year: "2024",
    team: "The Spoiler"
  },
  {
    name: "Scheckman",
    year: "2023",
    team: "Blessings be with you all"
  },
  {
    name: "Manny",
    year: "2022",
    team: "First or Last"
  },
  {
    name: "Bobby",
    year: "2021",
    team: "Bob's"
  },
  {
    name: "Filter",
    year: "2020",
    team: "CrabbyCaren with a C"
  },
  {
    name: "AJ",
    year: "2019",
    team: "PLAYOFFS 🏃💨"
  },
  {
    name: "Terry",
    year: "2018",
    team: "1 More Week of FF 😭"
  },
  {
    name: "Terry",
    year: "2017",
    team: "No More FF... 😭😭😭"
  }
];

const PastChampions = () => {
  return (
    <div className="champions-page">
      <div className="champions-hero">
        <div className="hero-content">
          <h1 className="hero-title">Hall of Champions</h1>
          <p className="hero-subtitle">Celebrating the legends who conquered The Golden Goose</p>
        </div>
      </div>
      
      <div className="champions-container">
        <div className="champions-grid">
          {champions.map((champion, index) => (
            <div key={index} className="champion-card">
              <div className="champion-trophy">
                <div className="trophy-icon">🏆</div>
                <div className="trophy-glow"></div>
              </div>
              <div className="champion-info">
                <div className="champion-name">{champion.name}</div>
                <div className="champion-year">{champion.year}</div>
                <div className="champion-team">{champion.team}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PastChampions;
